/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ContactUsImg from "../../Assets/contactusimage-new.jpg";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";
import VtigerContactForm from "../../Components/VtigerContactForm/VtigerContactForm";
import "../../Assets/css/contact_vtiger.css";
import { trackEvent } from "../../Components/Utility/Utility";
import { toast } from "react-toastify";

const ContactUs = () => {
  const translation = getTranslationData();
  //const [contactHtml, setContactHtml] = useState("");
  const clientinfo = useSelector((state) => state.clientDataReducer);
  // const containerRef = useRef(null);
  // const formDomRef = useRef(null);
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [urlExists, setUrlExists] = useState(false);
  sessionStorage.setItem(
    "contactFormTokenSuccessMessage",
    translation?.contactFormTokenSuccessMessage ||
      "Your query has been submitted successfully. We will get back to you shortly.",
  );
  sessionStorage.setItem(
    "contactFormTokenErrorMessage",
    translation?.contactFormTokenErrorMessage ||
      "Failed to submit request. Please try again later.",
  );
  useEffect(() => {
    trackEvent("page_browse", {
      page_title: "contact us",
      page_url: window.location.href,
    });
  }, []);
  useEffect(() => {
    const checkContactForm = async () => {
      const url = `/contactUsForm/${clientinfo.clientCode}/contactus.html`;

      try {
        const response = await fetch(url);
        const html = await response.text();

        // Check if actual Vtiger form exists
        if (html.includes("__vtigerWebForm_")) {
          setUrlExists(true);
        } else {
          setUrlExists(false);
        }
      } catch (error) {
        setUrlExists(false);
      }
    };

    if (clientinfo?.clientCode) {
      checkContactForm();
    }
  }, [clientinfo?.clientCode]);

  return (
    <>
      <section className="contact_us_page">
        <ScrollToTop />
        <div className="py-0 py-md-4 contact-row">
          {/* Banner Section */}
          <div className="row justify-content-center mb-4 hide-banner-contactus">
            <div className="col-md-8">
              <div className="d-flex justify-content-center position-relative">
                <h2 className="contact_banner_text">
                  {translation?.howCanWe} <br /> {translation?.helpYouToday}
                </h2>
                <img
                  src={ContactUsImg}
                  alt="banner"
                  className="contact_us_banner"
                />
              </div>
            </div>
          </div>
          {urlExists && (
            <div className="row container justify-content-center contact_us_form_box">
              <div className="col-md-5">
                <div className="contact_form_container">
                  <div className="client_contact_header">
                    <h2>Contact Us</h2>
                    <p>Facing issue with your order? Reach out to us.</p>
                  </div>
                  <iframe
                    ref={iframeRef}
                    title="Contact Form"
                    src={`/contactUsForm/${clientinfo.clientCode}/contactus.html`}
                    className="contact_iframe"
                    width="100%"
                    height="850"
                    scrolling="no"
                  />
                </div>

                <div className="contact_form_text d-flex justify-content-center align-items-center mt-5">
                  <div className="contact_no_text hide-support-contactus">
                    {/* <p className="mb-0">{translation?.ReachUsAT}</p> */}
                    <p className="mb-0">
                      {translation?.contactus_number}
                      <small>{translation?.contact_available}</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ContactUs;
